import React from 'react';
require('../../scss/style.scss');

class PageNotFound extends React.Component {
    constructor(props) {
      super(props);
    }
    render(){
        alert();
        return(
            <div>
                Not Found
            </div>
        )
    }
}

export default PageNotFound;
